// Letras latinas con acentos/ñ/ü/ç, espacios, apóstrofos, puntos y guiones:
// nombres y topónimos reales incluyen "MALAVÉ", "GARCÍA-MUÑOZ", "L'Eliana",
// "Vila-real"... La antigua /[a-zA-Z]+$/ solo-ASCII bloqueaba todos ellos.
export const onlyLettersRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ\s'’.·-]+$/;
